export default function FormatDateString(isoString) {
  const date = new Date(isoString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // getUTCMonth() 0 ile başlar (0: Ocak, 1: Şubat, ...)
  const year = date.getUTCFullYear();

  return `${day}.${month}.${year}`;
}
